<script setup lang="ts">
enum SIZES {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}

const props = withDefaults(defineProps<{
  size: keyof typeof SIZES;
}>(), {
  size: SIZES.md,
});

const classes = computed(() => {
  switch (props.size) {
    case SIZES.lg:
      return '';
    case SIZES.sm:
      return '';
    case SIZES.md:
    default:
      return 'text-5xl 2xs:text-5xl xs:max-w-[60%] sm:max-w-[65%] hd:max-w-[70%] sm:text-6xl hd:text-heading mb-12';
  }
});
</script>

<template>
  <h1 :class="['font-semibold !leading-tight overflow-hidden inline-block', classes]">
    <span class="inline opacity-0 animate-fade animation-delay-300">
      <slot />
    </span>
    <span class="inline opacity-0 animate-fade animation-delay-400">
      <slot name="colored" />
    </span>
  </h1>
</template>
